import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  standardColours,
  greyColours,
  brandColours,
  fontSize,
  visuallyHidden,
} from '../../styles';
import { Container, Svg } from '../ui';
import Logo from '../Logo';
import padlockIcon from '../../images/padlock-icon.svg';

const StyledCheckoutHeader = styled.header``;

const StyledContainer = styled(Container)``;

const StyledInner = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;

  ${minBreakpointQuery.tsmall`
    padding-top: 22px;
    padding-bottom: 22px;
  `}

  ${minBreakpointQuery.mlarge`
    padding-top: 30px;
    padding-bottom: 30px;
  `}

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: ${greyColours.grey};
  }
`;

const StyledLogo = styled(Logo)``;

const StyledProcess = styled.ol`
  counter-reset: booking-process-counter;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 20px;
  width: 600px;
`;

const StyledStep = styled.li`
  counter-increment: booking-process-counter;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  flex-grow: 1;
  color: ${({ activated }) =>
    activated ? brandColours.tertiary : greyColours.darkPurplishGrey};
  ${fontSize(12)};
  line-height: 1;
  text-align: center;

  &:before {
    content: '';
    position: absolute;
    top: 10px;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: ${({ activated }) =>
      activated ? brandColours.tertiary : greyColours.darkPurplishGrey};
  }

  &:after {
    content: counter(booking-process-counter);
    position: relative;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    margin-bottom: 6px;
    height: 22px;
    width: 22px;
    background-color: ${standardColours.white};
    border: 2px solid
      ${({ activated }) =>
        activated ? brandColours.tertiary : greyColours.darkPurplishGrey};
    border-radius: 50%;
    box-shadow: 0 0 0 3px ${standardColours.white};
  }

  span {
    ${maxBreakpointQuery.tsmall`
      ${visuallyHidden()};
    `}
  }
`;

const StyledSecure = styled.div`
  display: flex;
  align-items: center;
`;

const StyledSecureIcon = styled(Svg)`
  margin: 0 10px;
  height: 27px;
  width: 22px;
  fill: ${brandColours.primary};

  ${minBreakpointQuery.mlarge`
    height: 29px;
    width: 24px;
  `}
`;

const StyledSecureText = styled.p`
  ${maxBreakpointQuery.mlarge`
    ${visuallyHidden()};
  `}
`;

const StyledHeading = styled.h1`
  ${visuallyHidden()};
`;

const CheckoutHeader = ({ step = 1 }) => (
  <StyledCheckoutHeader>
    <StyledContainer wide={true}>
      <StyledInner>
        <StyledLogo isCheckoutHeader={true} />
        <StyledProcess>
          <StyledStep activated={step > 0}>
            <span>Details</span>
          </StyledStep>
          <StyledStep activated={step > 1}>
            <span>Payment</span>
          </StyledStep>
          <StyledStep activated={step > 2}>
            <span>Confirmation</span>
          </StyledStep>
        </StyledProcess>
        <StyledSecure>
          <StyledSecureIcon image={padlockIcon} />
          <StyledSecureText>
            Secure <br />
            Checkout
          </StyledSecureText>
        </StyledSecure>
      </StyledInner>
      <StyledHeading>Basket</StyledHeading>
    </StyledContainer>
  </StyledCheckoutHeader>
);

export default CheckoutHeader;
